const typography = {
	h1: {
		fontFamily: 'Open Sans',
		fontSize: 30,
		fontWeight: 700,
		textTransform: 'uppercase',
	},
	h2: {
		fontFamily: 'Open Sans',
		fontSize: 24,
		fontWeight: 700,
		textTransform: 'uppercase',
	},
	h3: {
		fontFamily: 'Open Sans',
		fontSize: 22,
		fontWeight: 700,
		textTransform: 'uppercase',
	},
	h4: {
		fontFamily: 'Open Sans',
		fontSize: 20,
		fontWeight: 700,
		textTransform: 'uppercase',
	},
	h5: {
		fontFamily: 'Roboto',
		fontSize: 18,
		fontWeight: 500,
	},
	h6: {
		fontFamily: 'Roboto',
		fontSize: 16,
		fontWeight: 500,
	},
	subtitle1: {
		fontFamily: 'Roboto',
		fontSize: 14,
		fontWeight: 500,
		// color: palette.grey.dark
	},
	subtitle2: {
		fontFamily: 'Roboto',
		fontSize: 13,
		fontWeight: 500,
	},
	body1: {
		fontFamily: 'Roboto',
		fontSize: 14,
		fontWeight: 400,
	},
	body2: {
		fontFamily: 'Roboto',
		fontSize: 13,
		fontWeight: 400,
	},
	button: {
		fontFamily: 'Open Sans',
		fontSize: 16,
		fontWeight: 600,
	},
	caption: {
		fontFamily: 'Roboto',
		fontSize: 14,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	overline: {
		fontSize: 14,
		fontWeight: 500,
		textTransform: 'uppercase',
	},
};

export default typography;